import {useCallback, useEffect, useRef, useState} from 'react';

const ONE_SECOND = 1000;

/**
 * Hook that returns the current countdown value and a method to cancel the counter.
 * If the value reaches the `limit` it will also stop.
 * @param {number} value initial countdown value
 * @param {number} limit when limit is reached, the countdown stops
 * @param {bool} active if the countdown is active or not
 * @returns array with countdown value and cancel function
 */
const useCountdown = (value, limit, active) => {
  const [countdowm, setCountdown] = useState(value);
  const isComponentMounted = useRef();
  const intervalId = useRef(null);

  const cancel = useCallback(() => {
    clearInterval(intervalId.current);
  }, []);

  useEffect(() => {
    isComponentMounted.current = true;

    return function () {
      isComponentMounted.current = false;

      clearInterval(intervalId.current);
    };
  }, []);

  useEffect(() => {
    if (active) {
      const id = setInterval(() => {
        if (!isComponentMounted.current) {
          return;
        }

        setCountdown((oldCount) => {
          if (oldCount - 1 >= limit) {
            return oldCount - 1;
          }
          clearInterval(intervalId.current);

          return 0;
        });
      }, ONE_SECOND);

      intervalId.current = id;
    }

    return () => {
      clearInterval(intervalId.current);
    };
  }, [active, limit]);

  return [countdowm, cancel];
};

export default useCountdown;
